import React from "react";
import { NavLink } from "react-router-dom";
import "./index.css";

const Cards = () => {
  const services = [
    {
      number: "01",
      title: "Inspections",
      description: "We offer comprehensive service investigation and inspections for your businesses to ensure workplace safety compliance."
    },
    {
      number: "02",
      title: "Reviews",
      description: "We offer reviews of your findings for all types of businesses and provide professional advice on how you can improve."
    },
    {
      number: "03",
      title: "Consulting",
      description: "We help and advise large and small businesses with tailored health and safety solutions."
    }
  ];

  return (
    <section id="services">
      <div className="max-width">
        <h2 className="title">
          What Be Safe Keep Safe Can Do For You
        </h2>

        <div className="serv-content">
          {services.map((service, index) => (
            <div className="card" key={index}>
              <div className="box">
                <div className="text">
                  {service.number}
                </div>
                <h3 style={{
                  fontSize: '1.25rem',
                  fontWeight: '600',
                  color: '#0a0a0a',
                  marginBottom: '0.75rem'
                }}>
                  {service.title}
                </h3>
                <p>{service.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="learn">
          <NavLink to="/" className="learnmore">
            Learn More Today
            <svg 
              width="18" 
              height="18" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </NavLink>
        </div>
      </div>
    </section>
  );
};

export default Cards;
